module.exports = __webpack_public_path__ + "d5fadc7f452f585e273d0266e43827a0.png";